import React from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';

/*
function Post() {
  let dataPost = [];
  let FetchPost = function() {
    let params = useParams();
    axios({
        method: 'post',
        url: 'post.php',
        headers: {
            'content-type': 'application/json'
        },
        data: params
    })
    .then(result => {
        console.log(result.data)

        this.setState({
            dataSent: result.data,
        })

        this.dataPost = result.data;
        console.log(this.state)
    })
    .catch(error => this.setState({
        error: error.message
    }));
  }
  FetchPost();
  return (
    <div>
      //<FetchPost />;
      ggfdgd fdgdfgdf fddfgdgdf
    </div>
  );
}
*/

class Post extends React.Component {
  constructor(props) {
    super(props);
    //console.log(this.props.match.params);
    //console.log(props);
    this.state = {dataSent: [],error: ''};
    console.log(this.props.postId);
    this.data = this.props.postId ? {'postId': this.props.postId} : "";
  }
  componentDidMount() {
    var data = new FormData();
    data.append('postId', this.props.postId);
    axios.post('../../post.php', data)
    .then(result => {
        console.log(result.data)
        this.setState({
            dataSent: result.data,
        })
        console.log(this.state)
    })
    .catch(error => this.setState({
        error: error.message
    }));
    /*
    axios({
        method: 'post',
        url: '../post.php',
        headers: {
            'content-type': 'application/json'
        },
        data: this.data
    })
    .then(result => {
        console.log(result.data)
        this.setState({
            dataSent: result.data,
        })
        console.log(this.state)
    })
    .catch(error => this.setState({
        error: error.message
    }));
    */
  }
  render() {
    let data = this.state.dataSent;
    return (
        data.map(d => (
          <div className="row" key={d.id}>
            <div className="column">
              <div className="card">
                <h2>{d.title}</h2>
                <p>{d.create_date}</p>
                <div className="fakeimg"><img src={'../../images/'+d.image} /></div>
                <p>{d.description}</p>
              </div>
            </div>
          </div>
        ))
    );
  }
}

export default Post;
